import * as THREE from "three";
import { DragonflyController } from './DragonflyController';
import { Twist, Vec3 } from "../../../../models/SyntheticMap";
import { normalizeAngleToPi } from "../../../../utils/spatial";
import { vec3Diff } from "../../../../visuals/visual-utils";
export class DragonflyLandController extends DragonflyController {
  status = "Landing";
  constructor(
    public obj: THREE.Object3D,
    public craft: THREE.Object3D,
    public approachSpeed = 3.0, // m/s
    public landingPoint: Vec3 = { x: 0, y: 0, z: 0 },
    public landingOrientation: Vec3 = { x: 0, y: 0, z: 0 }
  ) {
    super();
  }
  public static readonly APPROACH_ALT = 30.0; // meters
  private altGain = 0.1; // Altitude control gain
  private yawGain = 2.0; // Yaw control gain

  inVertMode = false;

  public computeTwist(dt: number): Twist | DragonflyController | string {
    const center = new THREE.Vector3(this.landingPoint.x, this.landingPoint.y, this.landingPoint.z);
    const centerPos = this.refToLocal(center);
    const flatDistance = Math.sqrt(centerPos.x ** 2 + centerPos.y ** 2);
    if (flatDistance > 5.0) {
      const toa = centerPos.clone();
      toa.z += DragonflyLandController.APPROACH_ALT;
      const vecToToa = Math.atan2(toa.y, toa.x);
      this.craft.rotation.y = DragonflyController.PITCH_NORM;
      // console.log(`vecToToa: ${vecToToa * Math.PI} heading: ${this.obj.rotation.z * Math.PI}`);
      const courseCorrection = vecToToa - this.obj.rotation.z;
      const x = Math.abs(courseCorrection) > 0.1 ? 1.0 : 2.0;
      return {
        linear: {
          x,
          y: 0,
          z: this.modulate(toa.z, 0.1, 2.0, 0.1)
        },
        angular: {
          x: 0,
          y: 0,
          z: this.modulate(courseCorrection * 0.75, 0.1, 1.5, 0.01)
        }
      };
    } else {
      const pitchCorrection = this.modulate((DragonflyController.PITCH_VERT - this.craft.rotation.y) * 2.0, 0.01, 2.0, 0.001);
      this.craft.rotation.y = normalizeAngleToPi(this.craft.rotation.y + pitchCorrection * dt);
      const angularCorrectionGain = 2.0;
      // const altDiff = this.landingPoint.z - this.obj.position.z;
      const linearCorrectionGain = 0.5;
      const rotationDelta = vec3Diff(this.landingOrientation, this.obj.rotation, true);
      if (Math.abs(centerPos.z) < 0.1) {
        return "Idle";
      }

      return {
        linear: this.modulateCorrection(centerPos, linearCorrectionGain, 0.15, 1.5, 0.05),
        angular: this.modulateCorrection(rotationDelta, angularCorrectionGain, 0.01, 2.0, 0.001)
      };
    }
  }

  public getStatus(): string {
    return this.status;
  }
}